// extracted by mini-css-extract-plugin
module.exports = {"DropdownContainer":"style_DropdownContainer__2_GWk","menu":"style_menu__2YExG"};